import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Framework from "@beardeddevops/react.framework";
import {Objects, Types, Collections} from "components";
import classNames from "classnames";

const breadcrumbsStatic = [{
	name: 'Help Desks',
	url: '/helpdesks',
	icon: 'comments',
}];

class HelpDesk extends Framework.Components.View {
	constructor(props) {
		super(props, 'helpdesk');
		this.state = {
			...this.state,
			ticket: null,
			customer: null,
			location: null
		}
	}

	setTicket = (ticket) => {
		this.setState({ticket: ticket})
	}

	setCustomerInfo = (customerId, locationId) => {
		this.setState({customer: customerId, location: locationId})
	}

	render() {
		let {match, history, baseUrl} = this.props;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: `Help Desk ${match.params.id}`,
				url: `/helpdesks/${match.params.id}`,
				icon: 'comments',
			}
		]);

		return (
			<div className={'container-fluid'}>

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

				<Tabs
					value={this.state.tab}
					onChange={this.handleTabChange}
					component={'div'}>
					<Tab label={'Help Desk'} value={'helpdesk'}/>
					{this.state.ticket && <Tab label={'Ticket Info'} value={'ticket'}/>}
				</Tabs>

				<div className={classNames({'hidden': this.state.tab !== 'helpdesk'})}>
					<Objects.HelpDeskDisplay
						id={match.params.id}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						baseUrl={baseUrl}
						noDelete={false}
						goBack={true}
						setTicket={this.setTicket}
					/>
				</div>

				<div className={classNames({'hidden': this.state.tab !== 'ticket'})}>
					<div className={"row"}>
						<div className={"col"}>
							<Objects.TicketDetails
								id={this.state.ticket}
								handle={this.setCustomerInfo}
								history={this.props.history}
								reloadShell={this.props.reloadShell}
								reloadPage={this.refreshPage}
								reloadSelf={this.state.refresh}
								baseUrl={baseUrl}
								noDelete={false}
								goBack={true}
							/>
						</div>
					</div>
					<div className={"row"}>
						<div className={"col-6"}>
							<Objects.Customer
								id={this.state.customer}
								history={history}
								noDelete={false}
							/>
						</div>
						<div className={"col-6"}>
							<Objects.CustomerLocation
								id={this.state.location}
								parent={this.state.customer}
								history={history}
								noDelete={false}
								afterSave ={this.handleAfterSave}
							/>
						</div>
					</div>
				</div>

			</div>
		)
	}
}

export default Framework.Components.withRootState(HelpDesk);